export const getUrlParameter = (name: string): string | null => {
    const urlParams = new URLSearchParams(window.location.search)
    const value = urlParams.get(name)
    return value
}

export const setCookie = (name: string, value: string, domain: string, days: number = 14) => {
    const expires = new Date()
    expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000)
    const cookieString = `${name}=${value}; expires=${expires.toUTCString()}; domain=${domain}; path=/; SameSite=Lax`
    document.cookie = cookieString
}

export const handlePasteFunctionality = (
    e: ClipboardEvent,
    isPasteFunctionalityEnabled: boolean,
    showError: (content: string) => void
) => {
    if (isPasteFunctionalityEnabled) {
        return
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const clipboardData = e.clipboardData || (window as any).clipboardData
    const items = clipboardData?.items

    if (items) {
        let containsImage = false
        for (const item of items) {
            if (item.type.startsWith('image/')) {
                containsImage = true
                break
            }
        }

        if (!containsImage) {
            showError('Pasting in the editor is disabled.')
            e.preventDefault()
        }
    }
}

export const formatTimeWithMilliseconds = (seconds: number) => {
    const totalMs = seconds * 1000
    const ms = Math.floor(totalMs % 1000)
    const totalSeconds = Math.floor(seconds)
    const s = totalSeconds % 60
    const m = Math.floor(totalSeconds / 60) % 60
    const h = Math.floor(totalSeconds / 3600)
    return `${h > 0 ? h + ':' : ''}${m.toString().padStart(2, '0')}:${s
        .toString()
        .padStart(2, '0')}.${ms.toString().padStart(3, '0')}`
}
